module.exports = __webpack_public_path__ + "img/icon-classics3-le_mattjones.6a7beea.png";